export default __webpack_public_path__ + "static/media/grid.492c8ee4.svg";